import React from "react";
import { Link } from "react-router-dom";
import { articles } from "../data/blogArticles";
import "./BlogStrip.css";

/* Four written articles, linked from the homepage. Each card is a real
   internal link to a prerendered article, which is the point: before this the
   only route to /blog was the navbar. */
const BlogStrip: React.FC = () => (
  <section className="blogstrip" aria-labelledby="blogstrip-heading">
    <div className="blogstrip-inner">
      <div className="blogstrip-head">
        <div>
          <p className="blogstrip-eyebrow">Astrology, Explained</p>
          <h2 className="blogstrip-heading" id="blogstrip-heading">
            Read from our blog
          </h2>
        </div>
        <Link to="/blog" className="blogstrip-all">
          View all blogs
          <span aria-hidden="true">&#8594;</span>
        </Link>
      </div>

      <div className="blogstrip-grid">
        {articles.map((article) => (
          <Link
            to={article.path}
            className="blogstrip-card"
            key={article.id}
          >
            <div className="blogstrip-media">
              <img src={article.img} alt={article.title} loading="lazy" />
            </div>
            <div className="blogstrip-body">
              <span className="blogstrip-tag">{article.tag}</span>
              <h3 className="blogstrip-title">{article.title}</h3>
            </div>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default BlogStrip;
